<script>
	let products;
	let original;
	let stores;
	let store;
	let newNames;
	let taxes;
	let fresh;
	import { frequencies, feels, formats } from '../fn.mjs';
	let states;
	import { onMount } from 'svelte';
	onMount(() => Promise.all([
		fetch('https://api.jsonbin.io/b/5db70785ce60505e47582601/latest').then(x => x.json()).then(x => {
			newNames = new Array(x.length);
			taxes = new Array(x.length);
			for(let i = 0; i < x.length; ++i) {
				newNames[i] = x[i].name;
				taxes[i] = x[i].tax;
			}
			stores = x;
		}),
		fetch('products.json').then(x => x.json()).then(x => {
			for(let i = 0; i < x.length; ++i) {
				x[i].UOM = "";
				x[i].img = [];
			}
			original = x;
		})
	]));
	function change_store() {
		if(original !== undefined) {
			products = JSON.parse(JSON.stringify(original));
		}
		states = [];
		if(store !== undefined) {
			for(const key in stores[store]) {
				switch(key) {
					case 'name':
					case 'tax':
						break;
					case 'diff':
						for(const i in stores[store].diff) {
							for(const what in stores[store].diff[i]) {
								let diff = stores[store].diff[i][what];
								if(Array.isArray(diff)) {
									products[i][what] = new Array(diff.length);
									for(let j = 0; j < diff.length; ++j) {
										products[i][what][j] = diff[j];
									}
								} else {
									products[i][what] = diff;
								}
							}
						}
						break;
					default:
						states[key] = JSON.parse(JSON.stringify(stores[store][key]))
				}
			}
		}
	}
	function put(obj) {
		return fetch('https://api.jsonbin.io/b/5db70785ce60505e47582601', {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'secret-key': '$2b$10$SrMwF.RldU1WmFzAoDfx/.9VYWx3pbWwKjI2gMIlBf22Xyy6/IyNK'
			},
			body: JSON.stringify(obj)
		});
	}
	async function save() {
		let diff = {};
		let addoutside = false;
		for(let i = 0; i < products.length; ++i) {
			let dif = {};
			let add = false;
			for(const key in products[i]) {
				const value = products[i][key];
				if(key === 'img') {
					if(value.length) {
						dif[key] = value;
						add = true;
					}
				} else if(key === 'terpenes') {
					if(original[i][key].length === value.length) {
						for(let j = 0; j < value.length; ++j) {
							if(value[j] !== original[i][key][j]) {
								dif[key] = value;
								add = true;
								break;
							}
						}
					} else {
						dif[key] = value;
						add = true;
					}
				} else if(original[i][key] !== value && key !== 'image_paths') {
					dif[key] = value;
					add = true;
				}
			}
			if(add) {
				diff[i] = dif;
				addoutside = true;
			}
		}
		let s = {name: newNames[store], tax: taxes[store]};
		if(addoutside) {
			s.diff = diff;
		}
		for(let i = 0; i < states.length; ++i) {
			if(states[i] !== undefined && states[i].length) {
				s[i] = states[i];
			}
		}
		let s2 = JSON.stringify(stores[store], null, '\t');
		let s3 = JSON.stringify(s, null, '\t');
		if(s2 === s3) {
			console.log('no change');
			return;
		}
		fresh = await(await fetch('https://api.jsonbin.io/b/5db70785ce60505e47582601/latest')).json();
		for(let i = 0; i < fresh.length; ++i) {
			if(fresh[i].name === stores[store].name) {
				let s1 = JSON.stringify(fresh[i], null, '\t');
				if(s1 === s2) {//no conflict, update
					console.log('normal');
					fresh[i] = s;
					stores = fresh;
					store = i;
					newNames = new Array(fresh.length);
					taxes = new Array(fresh.length);
					for(let i = 0; i < fresh.length; ++i) {
						newNames[i] = fresh[i].name;
						taxes[i] = fresh[i].tax;
					}
					return put(stores);
				} else {
					console.log('original:');
					console.log(s2);
					console.log('their change:');
					console.log(s1);
					console.log('your change:');
					console.log(s3);
					if(confirm("someone has edited this store and persisted their change while you were making yours. Would you like to overwrite their changes? Look in the developer console to see the details")) {//force update
						fresh[i] = s;
						stores = fresh;
						store = i;
						newNames = new Array(fresh.length);
						taxes = new Array(fresh.length);
						for(let i = 0; i < fresh.length; ++i) {
							newNames[i] = fresh[i].name;
							taxes[i] = fresh[i].tax;
						}
						return put(stores);
					} else {//user noticed changes they want to integrate
						return;
					}
				}
			}
		}
		console.log("have 2b new")
		//the store being edited no longer exists, so essentially add new store.
		return new_store(s, '', s.name, true);
	}
	async function del() {
		fresh = await(await fetch('https://api.jsonbin.io/b/5db70785ce60505e47582601/latest')).json();
		for(let i = fresh.length - 1; i >= 0; --i) {
			if(fresh[i].name === stores[store].name) {
				fresh.splice(i, 1);
				await put(fresh);
				break;
			}
		}
		newNames = new Array(fresh.length);
		taxes = new Array(fresh.length);
		for(let i = 0; i < fresh.length; ++i) {
			newNames[i] = fresh[i].name;
			taxes[i] = fresh[i].tax;
		}
		stores = fresh;
		store = undefined;
	}
	import { Link } from "svelte-routing";
	import EditProducts from '../components/EditProducts.svelte';
	import EditLightbox from '../components/EditLightbox.svelte';
	async function new_store(obj = {}, msg = 'new', name, fetched = false) {
		if(!fetched) {
			fresh = fetch('https://api.jsonbin.io/b/5db70785ce60505e47582601/latest');
		}
		if(name === undefined) {
			name = prompt('enter a name for the ' + msg + ' store');
		}
		if(!fetched) {
			fresh = await (await fresh).json();
		}
		for(let i = 0; i < fresh.length; ++i) {
			if(fresh[i].name === name) {
				alert('"' + name + '" already exists');
				return;
			}
		}
		obj.name = name;
		store = fresh.push(obj) - 1;
		stores = fresh;
		newNames = new Array(fresh.length);
		taxes = new Array(fresh.length);
		for(let i = 0; i < fresh.length; ++i) {
			newNames[i] = fresh[i].name;
			taxes[i] = fresh[i].tax;
		}
		await put(fresh);
	}
	function new_store_but_actually() {
		return new_store();
	}
	$: {
		store;
		change_store();
	}
	function copy_store() {
		new_store(stores[store], 'copied');
	}
	let edit;
</script>

<style>
	#header {
		position: sticky;
		top: 0;
		background: white;
		z-index: 1;
	}
	#wow {
		width: 10em;
	}
	#wow2 {
		width: 8.5em;
		position: absolute;
		left: .0;
	}
</style>

{#if stores !== undefined}
	<div id="header">
		<select id="wow" bind:value={store}>
			<option hidden disabled selected value={undefined}>{stores.length ? 'Select a store' : 'Create a store'}</option>
			{#each stores as _, i}
			<option value={i}>
				{newNames[i]}
			</option>
			{/each}
		</select>
		<button on:click={new_store_but_actually}>new</button>
		{#if store !== undefined}
			<button on:click={save}>save</button>
			<input id="wow2" bind:value={newNames[store]}>
			{#if stores.length > 1}
				<button on:click={del}>delete</button>
			{/if}
			<button on:click={copy_store}>copy</button>
			<Link getProps={() => ({id: 'zelda', style: 'float:right'})} to="/?store={stores[store].name}">front</Link>
			<button style="float:right" on:click={() => navigator.clipboard.writeText(document.getElementById('zelda').href)}>copy link</button>
		{/if}
	</div>
{/if}
{#if store !== undefined}
	<label>tax: <input type="number" bind:value={taxes[store]}></label><br>
	{#each frequencies as frequency, i}
		{#each feels as feel, j}
			{#each formats as format, k}
				<EditProducts
					label="{frequency}, {feel}, {format.join(' / ')}:"
					bind:products
					bind:states
					index={i * feels.length * formats.length + j * formats.length + k}
					bind:edit
					filter={item => format.some(f => f.toLowerCase() === item.type)}
				/>
			{/each}
		{/each}
	{/each}
	<EditProducts
		label="manual search / customer knows what they want:"
		bind:products
		bind:states
		index={18}
		bind:edit
	/>
{/if}
{#if edit !== undefined}
	<EditLightbox bind:products bind:edit />
{/if}